/**
 *
 * @returns ReactElement
 */
import { useEffect, useMemo, useState, useRef } from 'react';
import { useFm } from '@web3/base-hooks';
import cls from 'classnames';

import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';
import { Mousewheel } from 'swiper/modules';
import { Skeleton } from '@bfe/moly';
import 'swiper/css';
import 'swiper/css/mousewheel';
import 'swiper/swiper-bundle.css';

import { useScreenType } from '@/hooks/media';
import { useHomeStore } from '@/store/home';
import { ViewMore } from '@/components/ViewMore';
import { HotActivityCard } from './HotActivityCard';
import { Page } from '@/config/track-config';

type tabItems = 'Featured' | 'Ended' | string;
export function SectionHotActivity() {
  const { isMobile } = useScreenType();
  const fm = useFm();
  const [tab, setTab] = useState<tabItems>('featured');
  const [size] = useState(2);
  const [page, setPage] = useState(1);
  const [noMore, setNoMore] = useState(false);
  const [mainSwiper, setMainSwiper] = useState<SwiperClass>();
  const [dict, setDict] = useState<'prev' | 'next'>('prev');
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setisBeginning] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  const sliderRef = useRef<any>();

  const store = useHomeStore();
  const handleTabChange = (tabName: string) => {
    if (tabName === 'featured') {
      store.fetchFeaturedActivityList();
    } else {
      store.fetchEndedActivityList();
    }
    setTab(tabName as tabItems);
    setPage(1);
    setNoMore(false);
    typeof sliderRef.current?.slickGoTo === 'function' &&
      sliderRef.current?.slickGoTo(0);
  };
  useEffect(() => {
    store.fetchFeaturedActivityList().then((res) => {
      if (!res?.dataList.length) {
        setTab('ended');
      }
    });
    store.fetchEndedActivityList();

    // document.addEventListener('mousewheel', function (event) {
    //   if (event.deltaX !== 0) {
    //     event.preventDefault();
    //   }
    // });
  }, []);

  const tabs = useMemo(() => {
    const tabFeatured = { name: fm('featured'), key: 'featured' };
    const tabEnded = { name: fm('status_ended'), key: 'ended' };
    const tabArr = [];

    if (!store.featuredActivityListIsReady) {
      tabArr.push(tabFeatured);
    }

    if (store.featuredActivityList?.length) {
      tabArr.push(tabFeatured);
    }

    if (!store.endedActivityListIsReady) {
      tabArr.push(tabEnded);
    }
    if (store.endedActivityList?.length) {
      tabArr.push(tabEnded);
    }
    // if (!store.endedActivityList?.length) {
    // 	setTab('featured');
    // }
    return tabArr;
  }, [fm, store.featuredActivityList, store.endedActivityList]);

  useEffect(() => {
    setPage(1);
  }, [isMobile]);

  const dataList =
    useMemo(() => {
      const data =
        tab === 'featured'
          ? store.featuredActivityList?.filter(
              (item) => item.activityType !== 3
            )
          : store.endedActivityList?.filter(
              (item) => item.activityType !== 3
            ) ?? [];
      return isMobile ? data?.slice(0, page * size) : data ?? [];
    }, [
      isMobile,
      tab,
      store.featuredActivityList,
      store.endedActivityList,
      page,
      size,
    ]) ?? [];

  const loadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
  };

  useEffect(() => {
    const data =
      tab === 'featured' ? store.featuredActivityList : store.endedActivityList;
    setNoMore(page * size >= Number(data?.length));
  }, [page, store.featuredActivityList, store.endedActivityList, size, tab]);

  const swiperOptions = {
    slidesPerGroup: isMobile ? 1 : 2,
    spaceBetween: isMobile ? 20 : 24,
  };
  const displayPagination = isMobile
    ? dataList?.length > 1
    : dataList?.length > 2;

  const onSwiperNext = () => {
    setDict('next');
    if (!mainSwiper?.isEnd) {
      // 检查是否已经到达最后一页
      mainSwiper?.slideNext();
      // } else {
      //   console.log('已经到达最后一页');
    }
  };

  const onSwiperPrev = () => {
    setDict('prev');
    if (!mainSwiper?.isBeginning) {
      // 检查是否已经到达第一页
      mainSwiper?.slidePrev();
      // } else {
      //   console.log('已经到达第一页');
    }
  };
  return (
    <div className={cls(['section-hot-activity', isMobile ? '' : 'mt-16'])}>
      <div className="flex gap-4 !md:gap-8 tabs-wrap">
        {tabs?.map((item) => (
          <h1
            key={item.key}
            onClick={() => handleTabChange(item.key)}
            data-spm-even="Web3UserClick"
            data-spm-data={JSON.stringify({
              page_name: Page.AirdropArcadeHome,
              button_name: item.key === 'featured' ? 'TabFeatured' : 'TabEnded',
            })}
            className={cls([
              'font-semibold cursor-pointer hover:text-white',
              isMobile ? 'text-lg !leading-5' : '!leading-8 text-3hxl',
              tab === item.key ? 'tab-active  text-white' : 'text-gray1',
            ])}
          >
            {item.name}
          </h1>
        ))}
      </div>
      <div className="slider-container mt-7 !md:mt-8 relative">
        {isMobile && (
          <ViewMore loadMore={loadMore} noMore={noMore}>
            {dataList?.map((item, index) => (
              <HotActivityCard
                key={item.activityId}
                data={item}
                tab={tab}
                index={index}
              />
            ))}
          </ViewMore>
        )}
        {!isMobile && (
          <>
            {displayPagination ? (
              <>
                <div
                  className={cls('swiper-custom-prev', {
                    'swiper-custom-disable': dict === 'prev' && isBeginning,
                  })}
                  onClick={onSwiperPrev}
                ></div>
                <div
                  className={cls('swiper-custom-next', {
                    'swiper-custom-disable': dict === 'next' && isEnd,
                  })}
                  onClick={onSwiperNext}
                ></div>
              </>
            ) : null}
            <Swiper
              modules={[Mousewheel]}
              onSwiper={setMainSwiper}
              onSlideChange={(swiper) => {
                if (activeIndex < swiper.activeIndex) {
                  setDict('next');
                } else {
                  setDict('prev');
                }
                setActiveIndex(swiper.activeIndex);
                setIsEnd(swiper.isEnd);
                setisBeginning(swiper.isBeginning);
              }}
              mousewheel={true}
              slidesPerView="auto"
              slidesPerGroup={swiperOptions.slidesPerGroup}
              spaceBetween={swiperOptions.spaceBetween}
              className="mySwiper"
              speed={800}
              style={{
                paddingTop: 10,
              }}
            >
              {!store.featuredActivityListIsReady && (
                <>
                  <SwiperSlide className="!w-auto mr-6">
                    <Skeleton.Bar style={{ width: 500, height: 268 }} />
                  </SwiperSlide>
                  <SwiperSlide className="!w-auto mr-6">
                    <Skeleton.Bar style={{ width: 500, height: 268 }} />
                  </SwiperSlide>
                  <SwiperSlide className="!w-auto mr-6">
                    <Skeleton.Bar style={{ width: 500, height: 268 }} />
                  </SwiperSlide>
                </>
              )}
              {store.featuredActivityListIsReady &&
                dataList?.map((item, index) => (
                  <SwiperSlide key={index} className="!w-auto">
                    <HotActivityCard
                      key={item.activityId}
                      data={item}
                      tab={tab}
                      index={index}
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
          </>
        )}
      </div>
    </div>
  );
}
